"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OpenIcon = exports.TrueSelect = exports.VisualSelect = void 0;

var _tslib = require("tslib");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactFeather = require("react-feather");

var _styledSystem = require("styled-system");

var _Box = _interopRequireDefault(require("../../../Layout/Box"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var VisualSelect = (0, _styledComponents.default)(_Box.default)(templateObject_1 || (templateObject_1 = (0, _tslib.__makeTemplateObject)(["\n  border: 1px solid #757779;\n  position: relative;\n  display: flex;\n  flex-direction: row;\n\n  /* stylelint-disable no-descending-specificity */\n  :focus-within {\n    border-color: ", ";\n    outline: 2px solid black;\n    outline-offset: 2px;\n  }\n\n  ", "\n  ", "\n"], ["\n  border: 1px solid #757779;\n  position: relative;\n  display: flex;\n  flex-direction: row;\n\n  /* stylelint-disable no-descending-specificity */\n  :focus-within {\n    border-color: ", ";\n    outline: 2px solid black;\n    outline-offset: 2px;\n  }\n\n  ", "\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.orange;
}, _styledSystem.borderColor, _styledSystem.borderWidth);
exports.VisualSelect = VisualSelect;
var TrueSelect = (0, _styledComponents.default)(_Box.default)(templateObject_2 || (templateObject_2 = (0, _tslib.__makeTemplateObject)(["\n  appearance: none;\n  background: none;\n  outline: none;\n  border: none;\n  width: 100%;\n  border-radius: 0;\n  font-family: inherit;\n  font-weight: 500;\n\n  ::-ms-expand {\n    display: none;\n  }\n\n  ::-ms-value {\n    background: white;\n    color: black;\n  }\n\n  :focus::-ms-value {\n    background: ", ";\n    color: white;\n  }\n\n  :focus-within {\n    outline: none;\n  }\n"], ["\n  appearance: none;\n  background: none;\n  outline: none;\n  border: none;\n  width: 100%;\n  border-radius: 0;\n  font-family: inherit;\n  font-weight: 500;\n\n  ::-ms-expand {\n    display: none;\n  }\n\n  ::-ms-value {\n    background: white;\n    color: black;\n  }\n\n  :focus::-ms-value {\n    background: ", ";\n    color: white;\n  }\n\n  :focus-within {\n    outline: none;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.orange;
});
exports.TrueSelect = TrueSelect;
TrueSelect.defaultProps = {
  as: 'select',
  color: 'black',
  fontSize: 4,
  px: 4,
  py: 3
};
VisualSelect.defaultProps = {
  bg: 'white'
};
var OpenIcon = (0, _styledComponents.default)(_reactFeather.ChevronDown)(templateObject_3 || (templateObject_3 = (0, _tslib.__makeTemplateObject)(["\n  position: absolute;\n  top: 50%;\n  transform: translate(0, -50%);\n  right: 12px;\n  pointer-events: none;\n  ", "\n"], ["\n  position: absolute;\n  top: 50%;\n  transform: translate(0, -50%);\n  right: 12px;\n  pointer-events: none;\n  ", "\n"])), _styledSystem.color);
exports.OpenIcon = OpenIcon;
var templateObject_1, templateObject_2, templateObject_3;